export default __webpack_public_path__ + "static/media/simba_mobile_icon.ddb0e2d9.png";